'use client'

import { usePathname } from 'next/navigation'
import Footer from '@/components/footer'

export function ConditionalFooter() {
  const pathname = usePathname()
  
  // Skip rendering on dashboard pages - dashboard layout will handle the footer
  const isDashboardPath = pathname?.startsWith('/dashboard')
  // Skip rendering on AI proposal generator page
  const isAIProposalGeneratorPath = pathname?.startsWith('/ai-proposal-generator')
  
  if (isDashboardPath || isAIProposalGeneratorPath) {
    return null
  }
  
  // Render the footer for non-dashboard pages
  return <Footer />
} 